import { components } from "../openapi/generated-types";
import { getGame, getLeaderboard } from "../openapi/api-client";

type TeamReference = components["schemas"]["TeamReference"];

export const teamRefToTeamId = async (
  teamRef: TeamReference,
  competitionId: string,
): Promise<string | undefined> => {
  if ("teamId" in teamRef && teamRef.teamId) {
    return teamRef.teamId;
  }

  if ("winnerTeam" in teamRef && teamRef.winnerTeam) {
    const response = await getGame({
      gameId: teamRef.winnerTeam,
    });
    const result = response.data.result;
    if (result && "winnerTeamId" in result) {
      return result.winnerTeamId;
    }
  }

  if ("loserTeam" in teamRef && teamRef.loserTeam) {
    const response = await getGame({
      gameId: teamRef.loserTeam,
    });
    const result = response.data.result;
    if (result && "loserTeamId" in result) {
      return result.loserTeamId;
    }
  }

  if ("groupId" in teamRef && teamRef.groupId && "position" in teamRef) {
    const leaderboard = await getLeaderboard({
      groupId: teamRef.groupId,
      competitionId,
    });

    return leaderboard.data.leaderboard[teamRef.position - 1]?.teamId;
  }
};
